import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EmployeePage from "@/pages/EmployeePage";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import PointsLogPage from "@/pages/PointsLogPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ReportsLogin from "@/pages/ReportsLogin";
import ReportsView from "@/pages/ReportsView";
import ReportRender from "@/pages/ReportRender";
import SudokuPage from "@/pages/SudokuPage";
import WordBuildingPage from "@/pages/WordBuildingPage";
import TriviaPage from "@/pages/TriviaPage";
import DepartmentBattlesPage from "@/pages/DepartmentBattlesPage";
import CaptionPage from "@/pages/CaptionPage";
import PictionaryPage from "@/pages/PictionaryPage";
import ShopPage from "@/pages/ShopPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import { ShopOrdersPage, WishlistPage } from "@/pages/ShopExtraPages";
import ShopGate from "@/components/ShopGate";
import PlaytimeGuard from "@/components/PlaytimeGuard";
import ContentProtection from "@/components/ContentProtection";
import { TokenStripper } from "@/lib/session";
import { Toaster } from "sonner";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <TokenStripper />
      <ContentProtection />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/points" element={<PointsLogPage />} />
        <Route path="/play" element={<EmployeePage />} />
        <Route path="/rebus" element={<PlaytimeGuard><EmployeePage view="rebus" /></PlaytimeGuard>} />
        <Route path="/sudoku" element={<PlaytimeGuard><SudokuPage /></PlaytimeGuard>} />
        <Route path="/word" element={<PlaytimeGuard><WordBuildingPage /></PlaytimeGuard>} />
        <Route path="/trivia" element={<PlaytimeGuard><TriviaPage /></PlaytimeGuard>} />
        <Route path="/departments" element={<DepartmentBattlesPage />} />
        <Route path="/caption" element={<PlaytimeGuard><CaptionPage /></PlaytimeGuard>} />
        <Route path="/pictionary" element={<PlaytimeGuard><PictionaryPage /></PlaytimeGuard>} />
        <Route path="/shop" element={<ShopGate><ShopPage /></ShopGate>} />
        <Route path="/shop/cart" element={<ShopGate><CartPage /></ShopGate>} />
        <Route path="/shop/checkout" element={<ShopGate><CheckoutPage /></ShopGate>} />
        <Route path="/shop/orders" element={<ShopGate><ShopOrdersPage /></ShopGate>} />
        <Route path="/shop/wishlist" element={<ShopGate><WishlistPage /></ShopGate>} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/reports" element={<ReportsLogin />} />
        <Route path="/reports/view" element={<ReportsView />} />
        <Route path="/report-render" element={<ReportRender />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
